import { useEffect, useState } from "react";

/**
 * Reaktive Erkennung von Touch-Geräten. Zusätzlich wird bei einem ersten
 * `pointerdown`-Event vom Typ `touch` der Wert auf `true` gesetzt – so
 * funktioniert das auch auf Geräten, die sich initial nicht eindeutig
 * identifizieren lassen (z. B. iPads im Desktop-Modus).
 */
export function useIsTouchDevice(): boolean {
  const [isTouch, setIsTouch] = useState<boolean>(() => initialDetect());

  useEffect(() => {
    if (isTouch) return undefined;
    const handler = (event: PointerEvent) => {
      if (event.pointerType === "touch") {
        setIsTouch(true);
      }
    };
    window.addEventListener("pointerdown", handler, { passive: true });
    return () => window.removeEventListener("pointerdown", handler);
  }, [isTouch]);

  return isTouch;
}

function initialDetect(): boolean {
  if (typeof window === "undefined") return false;
  const navTouchPoints =
    typeof navigator !== "undefined" && navigator.maxTouchPoints
      ? navigator.maxTouchPoints
      : 0;
  return "ontouchstart" in window || navTouchPoints > 0;
}
